import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { UpdateSharepointConfigurationRequestDto } from '../../../infrastructure/dtos/update-sharepoint-configuration-request.dto';
import { SharepointConfigurationsRepository } from '../../../infrastructure/repositories/sharepoint-configurations.repository';
import { SharepointConfigurationsState } from '../../states/sharepoint-configurations.state';
import { UpdateSharepointConfigurationResult } from './update-sharepoint-configuration.result';

/**
 * Update SharePoint Configuration use case.
 * Updates the SharePoint configuration for the current tenant and updates state.
 */
@Injectable({ providedIn: 'root' })
export class UpdateSharepointConfigurationUseCase {
  private readonly _repository = inject(SharepointConfigurationsRepository);
  private readonly _state = inject(SharepointConfigurationsState);

  /**
   * Executes the update SharePoint configuration use case.
   * @param data - The SharePoint configuration data to update
   * @returns Observable with result containing the updated configuration ID
   */
  public execute(data: UpdateSharepointConfigurationRequestDto): Observable<UpdateSharepointConfigurationResult> {
    this._state.setSavingSharepointConfiguration(true);
    this._state.setErrorSharepointConfiguration(null);

    return this._repository.updateSharepointConfiguration(data).pipe(
      tap(() => {
        this._state.setSavingSharepointConfiguration(false);
      }),
      map((result) => ({ id: result.id })),
      catchError((error) => {
        this._state.setErrorSharepointConfiguration(error.message || 'Failed to update SharePoint configuration');
        this._state.setSavingSharepointConfiguration(false);
        throw error;
      }),
    );
  }
}
